import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-permiso-componente',
  templateUrl: './permiso-componente.component.html',
  styleUrls: ['./permiso-componente.component.scss'],
  providers: [MessagesTitles, MessagesStatus],
})
export class PermisoComponenteComponent {


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() CerrarPermisoComponente = new EventEmitter<boolean>();


  dataPermiso: any;
  dataPermisoRol: any;
  sistema: string;
  rol: string;
  checkEnable: boolean = false
  loading: boolean = false;
  isLoading: boolean = true;
  save: boolean = false;
  selection = new SelectionModel<any[]>(true, []);
  filtroPermiso: any = [];
  arrayPadre: any = [];
  repComponentes: any = [];
  repPermisos: any = [];
  checkboxStates = {}
  datosEnviar: any = [];
  datosEliminar: any = [];
  user: any;
  ipAddress: any;


  displayedColumns = ['checked', 'Componente'];
  dataSource: any = [];

  constructor(private securityService: SecurityService, private router: Router, private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    this.ObtenerListaComponentes();

    try {
      this.dataPermiso = this.securityService.dataPermiso;
      this.dataPermisoRol = this.securityService.dataPermisoRol;
      this.sistema = this.dataPermiso.Sistema;
      this.rol = this.dataPermisoRol.Nombre;
    } catch (error) {
      this.router.navigate(['/usuarios/listado']);
    }

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

  }


  ObtenerListaPermisos() {

    this.securityService.ObtenerListaPermisos(this.user.id_empresa)
      .subscribe(resp => {
        this.repPermisos = resp
        this.repPermisos.forEach(
          obj => {

            if (obj.id_roles === this.dataPermisoRol.id_roles) {
              this.filtroPermiso.push(obj);
            }
          }
        )
        this.filtroPermiso.forEach(item => {
          this.checkboxStates[item.id_componente] = true
        });


      }, (err: HttpErrorResponse) => {
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA PERMISOS. no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }


  ObtenerListaComponentes() {
    this.loading = true;
    let tc = 'Menu'
    this.securityService.ObtenerListaComponentes(tc)
      .subscribe(resp => {
        this.repComponentes = resp
        this.GetArrayComponentes();
        this.isLoading = false;
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA COMPONENTES no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }
  GetArrayComponentes() {
    this.repComponentes.forEach(item => {
      if (item.id_componente_padre == 0) {
        this.arrayPadre.push(item);
      }
      let idUlti = this.arrayPadre[this.arrayPadre.length - 1].id_componente
      for (let i = 1; i < idUlti + 1; i++) {
        if (item.id_componente_padre == i) {
          let indexx = this.arrayPadre.findIndex(xd => xd.id_componente == i);
          this.arrayPadre.splice(indexx + 1, 0, item);
        }
      }
    });

    this.dataSource = new MatTableDataSource(this.arrayPadre);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.ObtenerListaPermisos();

    this.arrayPadre.forEach(item => {
      this.checkboxStates[item.id_componente] = false
    });
  }

  guardarPermiso() {
    this.datosEnviar = [];
    this.datosEliminar = [];
    this.arrayPadre.forEach(item => {

      if (this.checkboxStates[item.id_componente]) {
        this.datosEnviar.push(
          {
            'id_roles': this.dataPermisoRol.id_roles,
            'id_componente': item.id_componente,
            'NombreProyecto': 'DigitalFactoring',
            'Usuario': this.user.Usuario,
            'Host': 'INTRANET',
            'IP': this.ipAddress.ip,
            'Canal': 'W'
          }
        )
      }
    });
    if (this.datosEnviar.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "seleccione al menos 1 check",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }
    if (this.filtroPermiso.length == 0) {
      this.securityService.RegistrarPermiso(this.datosEnviar)
        .subscribe(() => {
          Swal.fire({
            title: "Éxito",
            text: "Permiso guardado correctamente.",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitAfterResponse(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "PERMISO NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });

    }

    let datosNew = this.datosEnviar.filter(obj => {
      const exists = this.filtroPermiso.some(obj2 => (
        obj2.id_componente === obj.id_componente
      ));
      if (!exists) {
        return obj;
      }
    })

    let datosEliminar = this.filtroPermiso.filter(obj => {
      const exists = this.datosEnviar.some(obj2 => (
        obj2.id_componente === obj.id_componente
      ));
      if (!exists) {
        return obj;
      }
    })
    datosEliminar.forEach(item => {
      this.datosEliminar.push(
        {
          'id_permisos': item.id_permisos,
          'NombreProyecto': 'DigitalFactoring',
          'Usuario': this.user.Usuario,
          'Host': 'INTRANET',
          'IP': this.ipAddress.ip,
          'Canal': 'W'
        }
      )

    });

    if (datosNew.length > 0 && datosEliminar.length > 0) {
      this.securityService.RegistrarPermiso(datosNew)
        .subscribe(() => {
          this.securityService.EliminarPermiso(this.datosEliminar)
            .subscribe(() => {
              Swal.fire({
                title: "Éxito",
                text: "Permiso actualizado correctamente",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              }).then(res => {
                this.emitAfterResponse(res);
              });
            }, (err: HttpErrorResponse) => {
              this.loading = false;
              this.msgStatus.getMessage(err.status);
              Swal.fire({
                title: this.msgTitulos.Error,
                text: "PERMISO NO ACTUALIZADO-DELETE. " + this.msgStatus.message,
                type: "error",
                allowOutsideClick: true,
                heightAuto: false
              })
            });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "PERMISO NO ACTUALIZADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });


    } else if (datosNew.length > 0) {
      this.securityService.RegistrarPermiso(datosNew)
        .subscribe(() => {
          Swal.fire({
            title: "Éxito",
            text: "Permiso agregado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitAfterResponse(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "PERMISO NO AGREGADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else if (datosEliminar.length > 0) {
      this.securityService.EliminarPermiso(this.datosEliminar)
        .subscribe(() => {
          Swal.fire({
            title: "Éxito",
            text: "Permiso eliminado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.emitAfterResponse(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "PERMISO NO ELIMINADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }
  }

  emitAfterResponse(res: SweetAlertResult) {
    if (res.value) {
      this.CerrarPermisoComponente.emit();
    }
  }

  CerrarPopUp() {
    this.CerrarPermisoComponente.emit();
    this.securityService.dataPermiso = '';
  }

  changeCheckBoxesStatus(e: MatCheckboxChange) {
    if (e.checked) {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = true;
      })
    } else {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = false;
      })
    }
  }
}
